import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../provider/AuthProvider"; // Use your context
import { Box, CircularProgress } from "@mui/material";
import { hasPermission } from "../services/pemissions";

const PrivateRoute = ({ children, permission, allowManagerOnly = false }) => {
  const { user, loading } = useUser();
  console.log(user);
  if (loading)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (permission && !hasPermission(user, permission)) {
    return <Navigate to="/unauthorized" replace />;
  }
  if (allowManagerOnly && user.role !== "MANAGER") {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default PrivateRoute;
